import PropTypes from 'prop-types';
import React from 'react';
import _ from 'underscore';


const MediumVehicleIcon = ({
  color,
  heading = 0,
  onBreak = false,
  animateHeading = true,
}) => {
  // eslint-disable-next-line max-len
  const borderPath = 'M9,23 C13.9705627,23 18,18.9705627 18,14 C18,9.02943725 13.9705627,0 9,0 C4.02943725,0 0,9.02943725 0,14 C0,18.9705627 4.02943725,23 9,23 Z';

  // eslint-disable-next-line max-len
  const pausePath = 'M3.3,10 L5.1,10 L5.1,2.8 L3.3,2.8 L3.3,10 Z M6.9,10 L8.7,10 L8.7,2.8 L6.9,2.8 L6.9,10 Z';

  const dropshadowId = _.uniqueId('dropshadow');
  const contrast = '#ffffff';

  return (
    <svg
      width="35px"
      height="35px"
      viewBox="-5 -5 40 40"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <filter id={dropshadowId} y="-40%" height="180%" x="-40%" width="180%">
        <feOffset dx="1" dy="1" in="SourceAlpha" result="offset1" />
        <feGaussianBlur stdDeviation="2" in="offset1" result="blur1" />
        <feColorMatrix
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
          in="blur1"
          result="matrix1"
        />
        <feMerge>
          <feMergeNode in="matrix1" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
      </filter>
      <g
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
        style={{filter: `url(#${dropshadowId})`}}
      >
        <g
          style={{transition: animateHeading ? 'transform 6s ease' : 'transform 0s ease'}}
          transform={`translate(6.000000, 1.000000) rotate(${heading} 9 14)`}
        >
          <path d={borderPath} stroke={contrast} strokeWidth="2" fill={color} />
          <circle fill={contrast} cx="9" cy="6" r="2" />
        </g>
        <g transform="translate(6.000000, 1.000000)">
          {(onBreak && (
            <g transform="translate(3.000000, 8.000000)">
              <polygon points="0 0 12 0 12 12 0 12" />
              <path
                d={pausePath}
                fill="#FFFFFF"
                fillRule="nonzero"
              />
            </g>
          )) || <circle fill={contrast} cx="9" cy="14" r="4" />}
        </g>
      </g>
    </svg>
  );
};

MediumVehicleIcon.propTypes = {
  color: PropTypes.string.isRequired,
  heading: PropTypes.number,
  onBreak: PropTypes.bool,
  animateHeading: PropTypes.bool,
};

export default MediumVehicleIcon;



// WEBPACK FOOTER //
// ./src/common/components/VehicleOverlayMarker/MediumVehicleIcon.js